import React, { Component } from 'react';
import {
  Dropdown,
  Input
} from 'semantic-ui-react';
import fuzzysearch from 'fuzzysearch'

class LocalSearchDropdown extends Component {
  state = { search: '' }

  handleSearchChange = (e) => {
    this.setState({ search: e.target.value })
  }

  handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      const filtered = this.getFilteredTypes()
      if (filtered.length >= 1) {
        this.props.onItemSelected(filtered[0])
      } else {
        this.props.onItemSelected(undefined)
      }
      this.setState({ search: '' })

    }
  }

  getFilteredTypes() {
    return this.props.options.filter(p => {
      if (this.state.search === undefined) {
        return true
      }
      const search = this.state.search.toUpperCase()
      return fuzzysearch(search, this.props.mapToSearchString(p).toUpperCase())
    })
  }

  render = () => (
    <Dropdown
      inline
      icon='setting'
      name='docType'
      open={this.props.open}
      onClick={this.props.onClick}
      onBlur={this.props.onBlur}
    >
      <Dropdown.Menu>
        <Dropdown.Header onClick={e => e.stopPropagation()} content={this.props.headers[0]} />
        <Input
          onKeyDown={this.handleSearchKeyPress.bind(this)}
          onChange={this.handleSearchChange.bind(this)}
          value={this.state.search}
          icon='search'
          iconPosition='left'
          name='search'
        />
        <Dropdown.Header onClick={e => e.stopPropagation()} icon='tags' content={this.props.headers[1]} />
        <Dropdown.Menu scrolling>
          {this.getFilteredTypes().map((p, i) =>
            <Dropdown.Item
              onClick={this.props.onItemSelected.bind(this, p)}
              key={i}
              label={{ color: p.color || 'orange', empty: true, circular: true }}
              text={this.props.mapText(p)}
              value={p.value || p.id} />
          )}
        </Dropdown.Menu>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default LocalSearchDropdown;


// WEBPACK FOOTER //
// ./src/component/LocalSearchDropdown.js